
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Close'
})
export default class Close extends Vue {}
